import React from 'react';
import {CustomDialog, Dialog} from '@wix/wix-ui-tpa/cssVars';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {classes, st} from './EcomDialog.st.css';

type DialogProps = React.ComponentProps<typeof Dialog>;
type CustomDialogProps = React.ComponentProps<typeof CustomDialog>;

export function EcomDialog(props: DialogProps): React.ReactElement {
  const {className, ...rest} = props;
  const {isMobile, isPreview} = useEnvironment();
  const shouldAddHackClassNameForClassicMobilePreview = isMobile && isPreview;
  const dialogClassName = st(
    className,
    classes.formSectionColors,
    shouldAddHackClassNameForClassicMobilePreview ? classes.hackForClassicMobilePreview : undefined
  );

  return <Dialog {...rest} className={dialogClassName} />;
}

export function EcomCustomDialog(props: CustomDialogProps): React.ReactElement {
  const {className, ...rest} = props;
  const {isMobile, isPreview} = useEnvironment();
  const shouldAddHackClassNameForClassicMobilePreview = isMobile && isPreview;
  const dialogClassName = st(
    className,
    classes.formSectionColors,
    shouldAddHackClassNameForClassicMobilePreview ? classes.hackForClassicMobilePreviewCustomDialog : undefined
  );

  return <CustomDialog {...rest} className={dialogClassName} />;
}
